import React, { useState } from 'react';
import API from '../api/api';

export default function Login({ onLogin, onForgot }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await API.post('/auth/login/', { username, password });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data));
      onLogin(res.data);
    } catch (e) {
      setError(e.response?.data?.error || 'خطأ في تسجيل الدخول');
    }
    setLoading(false);
  };

  return (
    <div style={{minHeight:'100vh',background:'linear-gradient(135deg,#1e3a5f,#2980b9)',display:'flex',alignItems:'center',justifyContent:'center',direction:'rtl'}}>
      <div style={{background:'white',borderRadius:'16px',padding:'40px',width:'360px',boxShadow:'0 20px 60px rgba(0,0,0,0.3)'}}>
        <div style={{textAlign:'center',marginBottom:'30px'}}>
          <div style={{fontSize:'48px',marginBottom:'10px'}}>💧</div>
          <h2 style={{color:'#1e3a5f',margin:0,fontSize:'22px'}}>نظام إدارة شراكات الآبار</h2>
          <p style={{color:'#888',fontSize:'13px',marginTop:'5px'}}>تسجيل الدخول</p>
        </div>
        {error && <div style={{background:'#ffeaea',color:'#c0392b',padding:'10px',borderRadius:'8px',marginBottom:'15px',fontSize:'13px',textAlign:'center'}}>{error}</div>}
        <div style={{marginBottom:'15px'}}>
          <label style={{display:'block',fontSize:'12px',fontWeight:'bold',color:'#555',marginBottom:'5px'}}>اسم المستخدم</label>
          <input value={username} onChange={e=>setUsername(e.target.value)}
            style={{width:'100%',padding:'10px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'14px',boxSizing:'border-box'}}
            placeholder="اسم المستخدم" onKeyDown={e=>e.key==='Enter'&&handleSubmit()}/>
        </div>
        <div style={{marginBottom:'20px'}}>
          <label style={{display:'block',fontSize:'12px',fontWeight:'bold',color:'#555',marginBottom:'5px'}}>كلمة المرور</label>
          <input type="password" value={password} onChange={e=>setPassword(e.target.value)}
            style={{width:'100%',padding:'10px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'14px',boxSizing:'border-box'}}
            placeholder="كلمة المرور" onKeyDown={e=>e.key==='Enter'&&handleSubmit()}/>
        </div>
        <button onClick={handleSubmit} disabled={loading}
          style={{width:'100%',padding:'12px',background:'#1e3a5f',color:'white',border:'none',borderRadius:'8px',fontSize:'15px',fontWeight:'bold',cursor:'pointer'}}>
          {loading ? 'جاري الدخول...' : 'دخول'}
        </button>

        {onForgot && <div style={{textAlign:'center',marginTop:'12px'}}>
          <button onClick={onForgot} style={{background:'none',border:'none',color:'#2980b9',cursor:'pointer',fontSize:'13px',textDecoration:'underline'}}>
            نسيت كلمة المرور؟
          </button>
        </div>}
        <div style={{marginTop:'30px',paddingTop:'20px',borderTop:'1px solid #eee',textAlign:'center'}}>
          <div style={{fontSize:'11px',color:'#aaa',marginBottom:'6px',letterSpacing:'0.5px'}}>
            ✦ فكرة وتصميم وبناء ✦
          </div>
          <div style={{fontSize:'13px',fontWeight:'bold',color:'#1e3a5f',marginBottom:'6px'}}>
            سعود بن محمد آل موسى
          </div>
          <a href="mailto:Saud.al.mossa@gmail.com"
            style={{fontSize:'11px',color:'#2980b9',textDecoration:'none',display:'flex',alignItems:'center',justifyContent:'center',gap:'4px'}}>
            <span>✉</span>
            <span>Saud.al.mossa@gmail.com</span>
          </a>
        </div>
      </div>
    </div>
  );
}
